import classnames from 'classnames2';
import * as PropTypes from 'prop-types';
import React from 'react';
import TetherComponent from 'react-tether';

import * as _ from 'lodash';

import styles from './Dropdown.scss';

const positions = [
  'top left',
  'top center',
  'top right',
  'middle left',
  'middle center',
  'middle right',
  'bottom left',
  'bottom center',
  'bottom right'
];

export class Dropdown extends React.Component<any, any> {
  static propTypes = {
    label: PropTypes.string,
    title: PropTypes.node,
    description: PropTypes.string,
    disabled: PropTypes.bool,
    onToggle: PropTypes.func,
    dropdownClass: PropTypes.string,
    targetClass: PropTypes.string,
    titleAttribute: PropTypes.string,
    hint: PropTypes.string,
    hintPosition: PropTypes.number,
    toggleClass: PropTypes.string,
    children: PropTypes.node,
    attachTo: PropTypes.oneOf(positions),
    attachment: PropTypes.oneOf(positions)
  };

  static defaultProps = {
    targetClass: 'ui-dropdown__target',
    attachment: 'top left',
    attachTo: 'bottom left',
    onToggle: _.noop
  };

  ignoreToggle: boolean;
  ignoreClick: boolean;

  state = {
    open: false
  };

  componentDidMount() {
    document.body.addEventListener('click', this.handleDocumentClick);
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.handleDocumentClick);
  }

  handleToggleClick = () => {
    if (this.props.disabled) {
      return;
    }

    if (!this.ignoreToggle) {
      this.toggle();
    }
    this.ignoreClick = true;
    this.ignoreToggle = false;
  };

  handleContentClick = () => {
    if (this.props.ignoreContentClicks) {
      this.ignoreToggle = true;
    }
  };

  handleDocumentClick = () => {
    // Allow the handleClick handler a chance to run first
    // before checking if we should toggle the menu closed.
    // It isn't defined what order the click handlers will run.
    _.defer(() => {
      if (!this.ignoreClick && this.state.open) {
        this.toggle();
      }
      this.ignoreClick = !this.ignoreClick;
    });
  };

  // When calling this from a click event listener be sure to
  // pass true for ignoreClick otherwise the menu will never open.
  toggle = (ignoreClick?: boolean) => {
    const opening = !this.state.open;
    this.setState({ open: opening });

    const onToggle = this.onToggle;
    if (onToggle) {
      onToggle(opening);
    }

    this.ignoreClick = ignoreClick;
  };

  onToggle = opening => {
    this.props.onToggle(opening);
  };

  render() {
    const dropdownClassMixin = {
      disabled: this.props.disabled,
      'is-toggled': this.state.open,
      multiline: this.props.description
    };

    const dropdownClass = classnames('ui-dropdown', styles.dropdown, this.props.dropdownClass, dropdownClassMixin);

    const targetClass = classnames(this.props.targetClass, styles.resetPosition);

    const { attachment, attachTo: targetAttachment } = this.props;

    return (
      <div
        className={dropdownClass}
        title={this.props.titleAttribute}
        data-hint={this.props.hint}
        data-hint-position={this.props.hintPosition}
        onClick={this.handleToggleClick}
      >
        <TetherComponent {...{ attachment, targetAttachment }}>
          <a className={this.props.toggleClass}>
            {this.props.label ? <small className="ui-dropdown__label">{this.props.label}</small> : null}
            {this.props.description ? (
              <span>
                <strong>{this.props.title}</strong>
                <small>{this.props.description}</small>
              </span>
            ) : (
              this.props.title
            )}
            {this.props.tag && <span className="ui-dropdown__tag">{this.props.tag}</span>}
          </a>
          {this.state.open && (
            <div
              className={classnames(styles[`default-tether`], targetClass)}
              style={{ display: 'block' }}
              onClick={this.handleContentClick}
            >
              {this.props.children}
            </div>
          )}
        </TetherComponent>
      </div>
    );
  }
}
